<template>
  <field-facility-complex-write
    :breadcrumb="breadcrumb"
    :field-code="fieldCode"
  />
</template>

<script>
import FieldFacilityComplexWrite from "@/views/_BS/FieldFacilityComplexWrite.vue";

export default {
  name: "ComplexLibraryWrite",
  components: {FieldFacilityComplexWrite},
  data() {
    return {
      fieldCode: 'library',
      breadcrumb : [
        { title: 'Home' },
        { title: '중대시민재해 대상시설 현황' },
        { title: '공중이용시설' },
        { title: '도서관', active: true }
      ]
    }
  },
  created() {
    // 메뉴 활성화를 위해서, 라우트에 설정된 activeCode 값을 갱신한다
    // this.$route.meta.activeCode = `complex-${this.fieldCode}`;
  }
}
</script>


<style scoped>

</style>
